export default __webpack_public_path__ + "static/media/corazon-gris.713d6c61.png";